import { Box, MenuItem } from '@mui/material';
import { UPDropdownHelperText } from 'components/dropdown/styles';
import {
  UPInputDivider,
  UPInputFormControl,
  UPInputLabel,
  UPInputSelect,
  UPInputTextField,
} from 'components/input/styles';
import { useMemo } from 'react';
import { CurrencyNumberInputProps } from './types';

const CurrencyNumberInput = (props: CurrencyNumberInputProps): JSX.Element => {
  const {
    value,
    currencyType,
    currencyTypeList,
    className,
    sx,
    label,
    error,
    helperText,
    onChangeValue,
    onChangeCurrencyType,
  } = props;

  const handleInputChange = event => {
    const v = event.target.value;
    if (!Number.isNaN(v)) {
      onChangeValue(v);
    }
  };

  const endAdornment = useMemo((): JSX.Element => {
    return (
      <UPInputFormControl>
        <UPInputDivider orientation="vertical" />
        <UPInputSelect
          value={currencyType ?? currencyTypeList[0].value}
          onChange={e => {
            onChangeCurrencyType(e.target.value?.toString());
          }}
          variant="standard"
          disableUnderline
        >
          {currencyTypeList.map(i => (
            <MenuItem key={i.value} value={i.value}>
              {i.label}
            </MenuItem>
          ))}
        </UPInputSelect>
      </UPInputFormControl>
    );
  }, [currencyType, currencyTypeList, onChangeCurrencyType]);

  return (
    <Box className={className} sx={sx ?? { width: '100%' }}>
      <UPInputLabel>{label} *</UPInputLabel>
      <UPInputTextField
        value={value}
        onChange={handleInputChange}
        type="number"
        placeholder="+- X.xx"
        required
        InputProps={{
          endAdornment,
        }}
      />
      {error && <UPDropdownHelperText>{helperText}</UPDropdownHelperText>}
    </Box>
  );
};

export default CurrencyNumberInput;
